<div class="container-fluid">
    <div class="row mt-3">
        <div class="col">
            <div class="card">
                <div class="card-body">
                    <ul class="list-group list-group-horizontal">
                        <li class="list-group-item justify-content-between col" style="border:none;">
                            <div class="media">
                                <i class="fa fa-euro-sign align-self-start mr-4"
                                    style="font-size: 32px; padding-right: 20px; color: #95cc6b!important;"></i>
                                <div class="media-body">
                                    <span class="m-0 text-muted">Full price</span>
                                    <h5 class="m-0" style="color: #95cc6b!important;">
                                        <strong>{{eventOffer.fullPrice | currency:'€ '}}</strong>
                                    </h5>
                                </div>
                            </div>
                        </li>
                        <li class="list-group-item justify-content-between col" style="border:none;">
                            <div class="media">
                                <i class="fa fa-percent align-self-start mr-4"
                                    style="font-size: 32px; padding-right: 20px; color: #9e5ba1!important;"></i>
                                <div class="media-body">
                                    <span class="m-0 text-muted">Discount</span>
                                    <h5 class="m-0" style="color: #9e5ba1!important; ">
                                        <strong>{{eventOffer.discount}} %</strong>
                                    </h5>
                                </div>
                            </div>
                        </li>
                        <li class="list-group-item justify-content-between col" style="border:none;">
                            <div class="media">
                                <i class="fa fa-euro-sign align-self-start mr-4"
                                    style="font-size: 32px; padding-right: 20px; color: #9e5ba1!important;"></i>
                                <div class="media-body">
                                    <span class="m-0 text-muted">Client price (no VAT)</span>
                                    <h5 class="m-0" style="color: #9e5ba1!important; ">
                                        <strong>{{eventOffer.discountedPrice | currency:'€ '}}</strong>
                                    </h5>
                                </div>
                            </div>
                        </li>
                        <li class="list-group-item justify-content-between col" style="border:none;">
                            <div class="media">
                                <i class="fa fa-euro-sign align-self-start mr-4"
                                    style="font-size: 32px; padding-right: 20px; color: #2ba8e3!important;"></i>
                                <div class="media-body">
                                    <span class="m-0 text-muted">Client price (VAT)</span>
                                    <h5 class="m-0" style="color: #2ba8e3!important;">
                                        <strong>{{eventOffer.discountedPriceWithVat | currency:'€ '}}</strong>
                                    </h5>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col">
            <div class="card">
                <div class="card-header">
                    <i class="fa fa-credit-card" style="font-weight: normal;"></i><strong>Event Offer</strong>
                    [{{eventOffer.offerId}}]
                </div>
                <div class="card-body">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-xl-5" style="margin:5px 0">
                                    <button type="button" class="btn btn-sm btn-default btn-wd mr-3"
                                        (click)="downloadEventOfferPdf(eventOffer.offerId, eventOffer.versionLetter)"><i
                                            class="fa fa-file-pdf"></i>PDF</button>
                                </div>
                                <div class="col-12 col-xl-7" style="margin:5px 0"
                                    *ngIf="eventOffer.status == eventOfferStatusEnum.Accepted && !eventOffer.event">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text" style="margin:5px;">
                                                <input type="checkbox" aria-label="Checkbox for following text input"
                                                    [value]="true" [(ngModel)]="sendConvertionEmail">
                                                <span style="font-size: 12px;" class="ml-1">Send Email</span>
                                            </div>
                                        </div>
                                        <button type="button" class="btn btn-sm btn-success btn-wd"
                                            (click)="convertOfferToEventButtonClick()"><i
                                                class="fa fa-calendar-check"></i>Convert
                                            to event</button>
                                    </div>
                                </div>
                                <div class="col-12 col-xl-12" style="margin:5px 0">
                                    <a href="events/details/{{eventOffer.event.id}}" target="_blank"
                                        style="margin-top: -7px;" *ngIf="eventOffer.event"
                                        class="btn btn-sm btn-primary btn-wd mr-3"><i class="fa fa-share"></i> Go to Event</a>
                                    <div class="input-group" *ngIf="eventOffer.event"
                                        style="display: inline-flex; width: auto;">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text">
                                                <input type="checkbox" aria-label="Checkbox for following text input"
                                                    [value]="true" [(ngModel)]="sendConvertionEmail">
                                                <span style="font-size: 12px;" class="ml-1">Confirm</span>
                                            </div>
                                        </div>
                                        <button type="button" class="btn btn-sm btn-warning btn-wd"
                                            (click)="sendEventConfermationEmail()"><i class="fa fa-envelope"></i>
                                            Send confermation Email</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-3">
                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" id="status-tab" data-toggle="tab" href="#status" role="tab"
                                    aria-controls="status" aria-selected="true"><i class="fa fa-clock"></i>Status</a>
                            </li>
                        </ul>
                        <div class="tab-content" id="myTabContent">
                            <div class="tab-pane fade show active" id="status" role="tabpanel"
                                aria-labelledby="status-tab">
                                <div class="p-3" style="border: 1px solid #dee2e6; border-top: none;">
                                    <div class="form-group"
                                        *ngIf="choosenStatus == eventOfferStatusEnum.Canceled || choosenStatus == eventOfferStatusEnum.Rejected">
                                        <label>Reason:</label>
                                        <textarea class="form-control" [(ngModel)]="eventOffer.negativeNotes"
                                            rows="5"></textarea>
                                    </div>
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="input-group input-group-sm">
                                                <select class="form-control" [(ngModel)]="choosenStatus">
                                                    <option *ngFor="let status of eventOfferStatus"
                                                        [value]="status.value">{{status.label}}
                                                    </option>
                                                </select>
                                                <div class="input-group-append">
                                                    <button class="btn btn-outline-secondary" type="button"
                                                        id="button-addon2" (click)="changeEventOfferStatus()"><i
                                                            class="fa fa-save"></i> Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col">
                            <app-form-group-datepicker label="Pick Up Date" [(model)]="pickUpDate">
                            </app-form-group-datepicker>
                        </div>
                        <div class="col">
                            <app-form-group-datepicker label="Return Date" [(model)]="returnDate">
                            </app-form-group-datepicker>
                        </div>
                        <div class="col">
                            <button class="btn btn-primary btn-sm" style="height: 30px; margin-top: 19px" type="button"
                                (click)="changePickupReturnDate()"><i class="fa fa-save"></i> Change Date</button>
                        </div>
                    </div>
                    <hr />
                    <div>
                        <div class="row">
                            <dl class="col-4">
                                <dt>Event name</dt>
                                <dd>{{eventOffer.eventName}}</dd>
                            </dl>
                            <dl class="col-4">
                                <dt>Version</dt>
                                <dd>{{eventOffer.versionLetter}}</dd>
                            </dl>
                        </div>
                        <div class="row">
                            <dl class="col-3">
                                <dt>Start date</dt>
                                <dd>{{eventOffer.startDate | date:'dd-MM-yyyy'}}</dd>
                            </dl>
                            <dl class="col-3">
                                <dt>End Date</dt>
                                <dd>{{eventOffer.endDate | date:'dd-MM-yyyy'}}</dd>
                            </dl>
                            <dl class="col-3">
                                <dt>Pickup date</dt>
                                <dd>{{eventOffer.pickUpDate | date:'dd-MM-yyyy'}}</dd>
                            </dl>
                            <dl class="col-3">
                                <dt>Return Date</dt>
                                <dd>{{eventOffer.returnDate | date:'dd-MM-yyyy'}}</dd>
                            </dl>
                        </div>
                        <div class="row">
                            <dl class="col-3">
                              <dt>Country</dt>
                              <dd>{{eventOffer.country?.name}}</dd>
                            </dl>
                            <dl class="col-3">
                                <dt>Village</dt>
                                <dd>{{eventOffer.village?.name}}</dd>
                            </dl>
                            <dl class="col-3">
                                <dt>Zone</dt>
                                <dd>{{eventOffer.zone}}</dd>
                            </dl>
                            <dl class="col-3">
                                <dt>Language</dt>
                                <dd>{{eventOffer.language}}</dd>
                            </dl>
                            <dl class="col-3">
                                <dt>Created at</dt>
                                <dd>{{eventOffer.createdAt | date:'dd-MM-yyyy HH:mm'}}</dd>
                            </dl>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="card">
                                    <div class="card-body">
                                        <dl>
                                            <dt>Notes</dt>
                                            <dd>
                                                <div class="form-group">
                                                    <textarea class="form-control form-control-sm" rows="6"
                                                        #eventOfferNotes>{{eventOffer.notes}}</textarea>
                                                    <small class="help-text">
                                                        This notes will be shown in the offer PDF
                                                    </small>
                                                </div>
                                                <button type="button" class="btn btn-default btn-sm float-right"
                                                    (click)="updateEventOfferNotes(eventOfferNotes.value)"><i
                                                        class="fa fa-save"></i>Save</button>
                                            </dd>
                                        </dl>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="card">
                <div class="card-header">
                    Customer
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col">
                            <div class="card">
                                <div class="card-body">
                                    <ng-container *ngIf="!eventOffer.company; else existingCompanyTemplate">
                                        <dl class="row">
                                            <dt class="col-sm-4 text-right">Organization</dt>
                                            <dd class="col-sm-7">{{eventOffer.organizationName}}</dd>
                                            <dt class="col-sm-4 text-right">Organization Email</dt>
                                            <dd class="col-sm-7"><a
                                                    href="mailto:{{eventOffer.organizationEmail}}">{{eventOffer.organizationEmail}}</a>
                                            </dd>
                                            <dt class="col-sm-4 text-right">Title</dt>
                                            <dd class="col-sm-7">{{eventOffer.clientTitle}}</dd>
                                            <dt class="col-sm-4 text-right">Client</dt>
                                            <dd class="col-sm-7">{{eventOffer.clientName}}</dd>
                                            <dt class="col-sm-4 text-right">Client phone</dt>
                                            <dd class="col-sm-7">{{eventOffer.clientPhone}}</dd>
                                        </dl>
                                    </ng-container>
                                    <ng-template #existingCompanyTemplate>
                                        <dl>
                                            <dt>Organization</dt>
                                            <dd>{{eventOffer.company.name}}</dd>
                                        </dl>
                                        <dl>
                                            <dt>Email</dt>
                                            <dd><a
                                                    href="mailto:{{eventOffer.company.firstEmail}}">{{eventOffer.company.firstEmail}}</a>
                                            </dd>
                                        </dl>
                                        <dl>
                                            <dt>Phone</dt>
                                            <dd>{{eventOffer.company.firstPhone}}</dd>
                                        </dl>
                                    </ng-template>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="row">
                                <div class="col">
                                    <a href="companies/details/{{eventOffer.company?.id}}" target="_blank"
                                        class="btn btn-block btn-default btn-sm">View full
                                        details...</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col">
                            <ul ngbNav #editorNav="ngbNav">
                                <ng-container *ngIf="!eventOffer.delivery">
                                    <li [disabled]="true" [ngbNavItem]="'pickupTab'">
                                        <ng-template ngbNavLink>
                                            <h5 class="m-0"><i class="fa fa-box-open"></i> <strong
                                                    style="padding-left: 10px;">Pickup</strong></h5>
                                        </ng-template>
                                        <ng-template ngbNavContent>
                                            <div class="p-3" style="border: 1px solid #dee2e6; border-top: none;">
                                                <div class="row">
                                                    <div class="offset-3 col-5 text-center">
                                                        <div class="card border "
                                                            [ngClass]="{'border-success': eventOffer?.pickupPoint?.id === originPlaceEnum.Bolzano}">
                                                            <div class="card-footer">
                                                                <div class="form-check">
                                                                    <input class="form-check-input" type="radio"
                                                                        name="location" id="locationBolzano"
                                                                        [value]="originPlaceEnum.Bolzano"
                                                                        disabled="disabled" style="margin-top: 3px;">
                                                                    <label class="form-check-label"
                                                                        for="locationBolzano">
                                                                        {{eventOffer?.pickupPoint?.name}}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </li>
                                </ng-container>
                                <ng-container *ngIf="eventOffer.delivery">
                                    <li [disabled]="true" [ngbNavItem]="'deliveryTab'">
                                        <ng-template ngbNavLink>
                                            <h5 class="m-0"><i class="fa fa-truck-loading"></i> <strong
                                                    style="padding-left: 10px;">Delivery</strong>
                                            </h5>
                                        </ng-template>
                                        <ng-template ngbNavContent>
                                            <div class="p-3" style="border: 1px solid #dee2e6; border-top: none;">
                                                <div class="row">
                                                    <dl class="col-4">
                                                        <dt>Name</dt>
                                                        <dd>{{eventOffer.deliveryAddress.firstLastName}}</dd>
                                                    </dl>
                                                    <dl class="col-4">
                                                        <dt>Address</dt>
                                                        <dd>{{eventOffer.deliveryAddress.address}}</dd>
                                                        <dd>{{eventOffer.deliveryAddress.addressDetails}}</dd>
                                                    </dl>
                                                    <dl class="col-4">
                                                        <dt>Country</dt>
                                                        <dd>{{eventOffer.deliveryAddress.country.name}}</dd>
                                                    </dl>
                                                    <dl class="col-4">
                                                        <dt>Province</dt>
                                                        <dd>{{eventOffer.deliveryAddress.province}}</dd>
                                                    </dl>
                                                    <dl class="col-4">
                                                        <dt>City</dt>
                                                        <dd>{{eventOffer.deliveryAddress.city}}</dd>
                                                    </dl>
                                                    <dl class="col-4">
                                                        <dt>Post code</dt>
                                                        <dd>{{eventOffer.deliveryAddress.postcode}}</dd>
                                                    </dl>
                                                    <dl class="col-4">
                                                        <dt>Phone</dt>
                                                        <dd>{{eventOffer.deliveryAddress.phone}}</dd>
                                                    </dl>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </li>
                                </ng-container>
                            </ul>
                            <div [ngbNavOutlet]="editorNav"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mt-3">
                <div class="card-body">
                    <table class="table table-borderless">
                        <tbody>
                            <h4 style="margin: 0;">Software</h4>
                            <tr>
                                <td>
                                    <span class="btn btn-primary m-r-sm mr-3">{{eventOffer.softwareWaiter}}</span>
                                    <strong class="d-block">Waiters</strong>
                                </td>
                                <td>
                                    <span class="btn btn-primary m-r-sm mr-3">{{eventOffer.softwareMainDevice}}</span>
                                    <strong class="d-block">Main Device</strong>
                                </td>
                                <td>
                                    <span class="btn btn-primary m-r-sm mr-3">{{eventOffer.softwareCashRegister}}</span>
                                    <strong class="d-block">Cash Register</strong>
                                </td>
                                <td>
                                    <span class="btn btn-primary m-r-sm mr-3">{{eventOffer.softwarePrinter}}</span>
                                    <strong class="d-block">Printer</strong>
                                </td>
                              <td>
                                <span class="btn btn-primary m-r-sm mr-3">{{eventOffer.softwareFiscalPrinter}}</span>
                                <strong class="d-block">Fiscal Printer</strong>
                              </td>
                            </tr>
                            <tr>
                                <td colspan="7">
                                    <hr />
                                </td>
                            </tr>
                            <h4 style="margin: 0;">Hardware</h4>
                            <tr>
                                <td>
                                    <span class="btn btn-info m-r-sm mr-3">{{eventOffer.hardwarePhone}}</span>
                                    <strong class="d-block">Phones</strong>
                                </td>
                                <td>
                                    <span class="btn btn-info m-r-sm mr-3">{{eventOffer.hardwareTablet}}</span>
                                    <strong class="d-block">Tablet</strong>
                                </td>
                                <td>
                                    <span class="btn btn-info m-r-sm mr-3">{{eventOffer.hardwareRouter}}</span>
                                    <strong class="d-block">Router</strong>
                                </td>
                                <td>
                                    <span class="btn btn-info m-r-sm mr-3">{{eventOffer.hardwarePrinter}}</span>
                                    <strong class="d-block">Printer</strong>
                                </td>
                              <td>
                                <span class="btn btn-info m-r-sm mr-3">{{eventOffer.hardwareFiscalPrinter}}</span>
                                <strong class="d-block">Fiscal Printer</strong>
                              </td>
                                <td>
                                    <span class="btn btn-info m-r-sm mr-3">{{eventOffer.hardwareUps}}</span>
                                    <strong class="d-block">UPS</strong>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="7">
                                    <hr />
                                </td>
                            </tr>
                            <h4 style="margin: 0;">Cables</h4>
                            <tr>
                                <td>
                                    <span class="btn btn-warning m-r-sm mr-3">{{cableObject?.one}}</span>
                                    <strong class="d-block">1m</strong>
                                </td>
                                <td>
                                    <span class="btn btn-warning m-r-sm mr-3">{{cableObject?.five}}</span>
                                    <strong class="d-block">5m</strong>
                                </td>
                                <td>
                                    <span class="btn btn-warning m-r-sm mr-3">{{cableObject?.ten}}</span>
                                    <strong class="d-block">10m</strong>
                                </td>
                                <td>
                                    <span class="btn btn-warning m-r-sm mr-3">{{cableObject?.twenty}}</span>
                                    <strong class="d-block">20m</strong>
                                </td>
                                <td>
                                    <span class="btn btn-warning m-r-sm mr-3">{{cableObject?.fifty}}</span>
                                    <strong class="d-block">50m</strong>
                                </td>
                            </tr>
                            <tr>
                              <td colspan="7">
                                  <hr />
                              </td>
                            </tr>
                            <tr>
                              <td colspan="7">
                                <h4 style="margin: 0;">Additional costs</h4>
                              </td>
                            </tr>
                            <ng-container *ngFor="let additionalCost of this.additionalCostArray; let i = index">
                              <ng-container *ngIf="i >= 1">
                                <tr>
                                  <td colspan="7">
                                      <span class="btn btn-success m-r-sm mr-3">{{additionalCost.quantityRequested}}</span>
                                      <strong class="d-block">{{'event.additionalCosts.' + additionalCost.name + '.title' | translate}}</strong>
                                  </td>
                                </tr>
                                <hr />
                              </ng-container>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
            <ng-container *ngIf="eventOffer.company && offerCompanyPrinters.length !== 0">
                <div class="card-header" style="margin-top:30px">
                    <i class="fa fa-credit-card" style="font-weight: normal;"></i><strong>Organization own
                        printers</strong>
                </div>
                <div class="card">
                    <div class="card-body">
                        <table class="table table-borderless">
                            <tbody>
                                <tr>
                                    <td>
                                        <span class="btn btn-info m-r-sm mr-3">{{offerCompanyPrinters.length}}</span>
                                        <strong>Printer</strong>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="card ">
                        <div class="card-body ">
                            <div class="table-respnsive ">
                                <table class="table table-sm ">
                                    <thead>
                                        <tr>
                                            <th>Printer Id</th>
                                            <th>Printer Identifier</th>
                                            <th>Printer Name</th>
                                            <th>Printer Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let printer of offerCompanyPrinters">
                                            <td>{{printer.id}}</td>
                                            <td>{{printer.identifier}}</td>
                                            <td>{{printer.name}}</td>
                                            <td>{{printer.status | printerStatus}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <div class="card mt-3" *ngIf="existingEventOffers.length >= 1">
                <div class="card-body">
                    <table class="table">
                        <thead>
                            <tr>
                                <th class="text-center">VERSION</th>
                                <th>FULL PRICE</th>
                                <th>CLIENT PRICE (no VAT)</th>
                                <th>CLIENT PRICE (VAT)</th>
                                <th>CREATED AT</th>
                                <th class="text-center">PDF</th>
                                <th class="text-right">ACTIONS</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let offer of existingEventOffers">
                                <td class="text-center">{{offer.versionLetter}}</td>
                                <td>{{offer.fullPrice | currency: '€ '}}</td>
                                <td>{{offer.discountedPrice | currency: '€ '}}</td>
                                <td>{{offer.discountedPriceWithVat | currency: '€ '}}</td>
                                <td>{{offer.createdAt | date:'dd-MM-yyyy HH:mm'}}</td>
                                <td class="text-center"><button type="button" class="btn btn-sm btn-default"
                                        (click)="downloadEventOfferPdf(offer.offerId, offer.versionLetter)"><i
                                            class="fa fa-file-pdf"></i></button></td>
                                <td class="text-right"><a href="offers/details/{{offer.id}}" target="_blank"
                                        class="btn btn-secondary btn-sm"><i class="fa fa-search-plus"></i>
                                        View</a></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<app-loading-dialog-modal #loadingModal></app-loading-dialog-modal>
